import React, { useState, useEffect } from "react";
import "./advalert.css";

const AdvanceAlert = ({ advance }) => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    if (!advance.pdc_date) return; // Ensure the date exists

    // Check if the popup was dismissed earlier
    const dismissed = localStorage.getItem(`dismissed_${advance.pdc_date}`);
    if (dismissed) return;

    // Parse pdc_date correctly
    const pdcDate = new Date(advance.pdc_date);
    if (isNaN(pdcDate.getTime())) return; // Check if the date is valid

    // Get today's date without time
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    pdcDate.setHours(0, 0, 0, 0); // Normalize both dates

    // Compare dates
    if (pdcDate.getTime() === today.getTime()) {
      setShowPopup(true);
    }
  }, [advance.pdc_date]);

  const handleClose = () => {
    // Store dismissal state
    localStorage.setItem(`dismissed_${advance.pdc_date}`, "true");
    setShowPopup(false);
  };

  return (
    <div>
      {/* Popup Dialog */}
      {showPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white shadow-lg rounded-xl p-6 w-96 text-center">
            <h3 className="text-lg font-bold text-red-600">🔔 Reminder</h3>
            <p className="text-gray-800 mt-2">The PDC Date is today!</p>

            <div className="bg-gray-100 p-4 mt-3 rounded-md shadow-inner">
              <p className="text-gray-700 font-medium">
                <span className="font-bold">Client:</span> {advance.client_name}
              </p>
              <p className="text-gray-700 font-medium">
                <span className="font-bold">Amount:</span> ₹{advance.amount}
              </p>
              <p className="text-gray-700 font-medium">
                <span className="font-bold">Advance Date:</span>{" "}
                {advance.advance_date}
              </p>
            </div>

            <button
              onClick={handleClose}
              className="mt-4 px-4 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition duration-200"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdvanceAlert;
